// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TaskGroup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  taskGroupId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  displayOrder!: number;
  locationId!: number;
  lookupId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  tasks!: iTask[];
}

